<template>
  <div class="advertising" v-show="advertisingShow">
    <img class="advertising_close" @click.stop="advertisingShow = false" src="@/assets/img/advertising_close.png">
    <div class="advertising_content">
      <div class="app_icon">
        <img src="@/assets/img/advertise_logo.png" alt="FBM">
      </div>
      <div class="app_info">
        <div class="app_title">SEB - Pinjaman Online</div>
        <div class="app_subtitle">App Store</div>
      </div>
      <a href="https://apps.apple.com/id/app/id6754154331?l=id">
        <div class="download_btn">
          Download Aplikasi
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      advertisingShow: true
    }
  },
  methods: {
  }
}
</script>

<style scoped lang='less'>
.advertising {
  width: 100%;
  position: fixed;
  bottom: 0;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  padding: 12px 16px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
  z-index: 999;

  .advertising_close {
    position: absolute;
    left: 0px;
    top: -10px;
    width: 30px;
    height: 30px;

    &:active {
      opacity: 0.7;
    }
  }

  .advertising_content {
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;

    .app_icon {
      flex-shrink: 0;
      width: 70px;
      height: 70px;
      border-radius: 10px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .app_info {
      flex: 1;
      min-width: 0;

      .app_title {
        font-size: 28px;
        font-weight: 600;
        color: #ffffff;
        line-height: 1.3;
        margin-bottom: 2px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .app_subtitle {
        font-size: 20px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 1.3;
      }
    }

    .download_btn {
      background: linear-gradient(135deg, #5dade2 0%, #3498db 100%);
      color: #ffffff;
      font-size: 24px;
      font-weight: 600;
      padding: 10px 20px;
      border-radius: 40px;
      margin-right: 30px;
    }
  }
}
</style>
